'use client';

import { createContext, PropsWithChildren, useMemo, useState } from 'react';

export const TransitionContext = createContext<{
  onStart: (nextHref: string) => void;
  href: string;
}>({
  onStart: () => {},
  href: '/',
});

export function TransitionProvider({ children }: PropsWithChildren) {
  const [href, setHref] = useState('/');

  const value = useMemo(
    () => ({
      href,
      onStart: setHref,
    }),
    [href]
  );

  return (
    <TransitionContext.Provider value={value}>
      {children}
    </TransitionContext.Provider>
  );
}
